import { useLanguage } from "../hooks/useLanguage";

function PageSubtitle() {
  const { t } = useLanguage();
  return (
    <p className="page-subtitle">
      {t("verification.subtitle")}
    </p>
  );
}

export default PageSubtitle;
